(function () {
  "use strict";

  function init(container) {
    const scope = container || document;
    const switchers = scope.querySelectorAll('.shipping-switcher-container');
    
    switchers.forEach(container => {
      if (container.dataset.initialized) return;
      container.dataset.initialized = "true";

      const tabs = container.querySelectorAll('.shipping-tab');
      const indiaOnly = container.querySelectorAll('.india-only, .india-icons');
      const internationalOnly = container.querySelectorAll('.international-only, .international-icons');
      const buyNowInternational = container.querySelector('.buy-now-international');
      // Look for the variant select in the form — try multiple selectors
      const productForm = container.closest('form') || document.querySelector('.product-single__form');
      const variantSelect = productForm
        ? (productForm.querySelector('select[name="id"]') || productForm.querySelector('[data-product-select]'))
        : null;

      // Track availability state locally
      let isAvailable = container.dataset.available !== "false";

      function applyShippingType(type) {
        tabs.forEach((t) => t.classList.toggle('active', t.getAttribute('data-target') === type));
        container.setAttribute('data-shipping-type', type);

        if (type === 'india') {
          indiaOnly.forEach((el) => (el.style.display = isAvailable ? 'flex' : 'none'));
          internationalOnly.forEach((el) => (el.style.display = 'none'));
        } else {
          indiaOnly.forEach((el) => (el.style.display = 'none'));
          internationalOnly.forEach((el) => (el.style.display = isAvailable ? 'flex' : 'none'));
        }
      }

      function updateBuyNowAvailability(variantFound) {
        isAvailable = !!(variantFound && variantFound.available);
        container.dataset.available = isAvailable ? "true" : "false";
        const indiaContainer = container.querySelector('.buy-now-container.india-only');
        const currentType = container.getAttribute('data-shipping-type') || 'india';

        if (isAvailable) {
          if (indiaContainer) indiaContainer.style.display = currentType === 'india' ? 'flex' : 'none';
          if (buyNowInternational) {
            buyNowInternational.removeAttribute('disabled');
            buyNowInternational.closest('.buy-now-container').style.display = currentType === 'international' ? 'flex' : 'none';
          }
        } else {
          if (indiaContainer) indiaContainer.style.display = 'none';
          if (buyNowInternational) {
            buyNowInternational.setAttribute('disabled', 'disabled');
            buyNowInternational.closest('.buy-now-container').style.display = 'none';
          }
        }
      }

      // Initial state
      const currentType = container.getAttribute('data-shipping-type') || 'india';
      applyShippingType(currentType);

      // Tab clicks
      tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          const type = this.getAttribute('data-target');
          document.dispatchEvent(new CustomEvent('shippingType:change', { detail: { type } }));
        });
      });

      // Buy Now click
      if (buyNowInternational) {
        buyNowInternational.addEventListener('click', function () {
          if (this.hasAttribute('disabled')) return;
          const btn = this;

          // Get variant ID from multiple fallback sources
          let variantId = variantSelect ? variantSelect.value : null;

          // Fallback 1: any select[name="id"] on the page
          if (!variantId) {
            const anySelect = document.querySelector('select[name="id"], [data-product-select]');
            if (anySelect) variantId = anySelect.value;
          }

          // Fallback 2: URL ?variant= param
          if (!variantId) {
            const urlParams = new URLSearchParams(window.location.search);
            variantId = urlParams.get('variant');
          }

          // Fallback 3: data-variant-id on the product section
          if (!variantId) {
            const productSection = container.closest('[data-product-id]');
            if (productSection) variantId = productSection.getAttribute('data-product-id');
          }

          console.log('[Buy Now International] variantId:', variantId);

          if (!variantId) {
            console.error('[Buy Now International] Could not determine variant ID');
            return;
          }

          btn.setAttribute('disabled', 'disabled');
          const originalHTML = btn.innerHTML;
          btn.innerHTML = 'Processing...';

          // Step 1: Clear the cart so only the current product goes to checkout
          fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          })
          .then(function () {
            // Step 2: Add only the current product
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
            return response.json();
          })
          .then(function () {
            // Step 3: Go directly to checkout
            window.location.href = window.Shopify.routes.root + 'checkout';
          })
          .catch(function (error) {
            console.error('[Buy Now International] Error:', error);
            btn.removeAttribute('disabled');
            btn.innerHTML = originalHTML;
          });
        });
      }

      // Listen for variant changes at the document level (the theme dispatches on document)
      const productSection = container.closest('.product-section');
      document.addEventListener('variant:change', function (evt) {
        if (!productSection) return;
        updateBuyNowAvailability(evt.detail.variant);
      });
    });
  }

  // Global listeners (only once)
  if (!window.rasa_shippingGlobalListenersAdded) {
      document.addEventListener('shippingType:change', function (e) {
        document.querySelectorAll('.shipping-switcher-container').forEach(container => {
           // We can't easily call applyShippingType here because it's scoped.
           // So we'll just trigger a click on the tab if it's not active.
           const targetTab = container.querySelector(`.shipping-tab[data-target="${e.detail.type}"]`);
           if (targetTab && !targetTab.classList.contains('active')) {
             // We need to update the UI without re-triggering the event to avoid infinite loop
             // Actually, let's just make applyShippingType available.
           }
        });
        
        // Simpler: just update the attributes and let CSS/global logic handle it if possible.
        // But the current logic is in a closure.
      });
      window.rasa_shippingGlobalListenersAdded = true;
  }

  // Refactored global listener to be more robust
  document.addEventListener('shippingType:change', function (e) {
      const type = e.detail.type;
      document.querySelectorAll('.shipping-switcher-container').forEach(container => {
          const tabs = container.querySelectorAll('.shipping-tab');
          const indiaOnly = container.querySelectorAll('.india-only, .india-icons');
          const internationalOnly = container.querySelectorAll('.international-only, .international-icons');
          const buyNowInternational = container.querySelector('.buy-now-international');
          
          // We need to know if it's available. We'll store it on the container.
          const isAvailable = container.dataset.available !== "false";

          tabs.forEach((t) => t.classList.toggle('active', t.getAttribute('data-target') === type));
          container.setAttribute('data-shipping-type', type);

          if (type === 'india') {
            indiaOnly.forEach((el) => (el.style.display = isAvailable ? 'flex' : 'none'));
            internationalOnly.forEach((el) => (el.style.display = 'none'));
          } else {
            indiaOnly.forEach((el) => (el.style.display = 'none'));
            internationalOnly.forEach((el) => (el.style.display = isAvailable ? 'flex' : 'none'));
          }
      });
  });

  window.rasa = window.rasa || {};
  window.rasa.initShippingSwitcher = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
